import { useEffect } from 'react';
import api from '../api/client';

// Phase 87 — presence heartbeat: 60s ping (paused while tab hidden) for
// BOTH logged members (auth header → member) and anonymous guests
// (stable visitor_id in localStorage → guest).
const PING_INTERVAL_MS = 60 * 1000;

const getVisitorId = () => {
  try {
    let vid = localStorage.getItem('nymia_vid');
    if (!vid) {
      vid = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem('nymia_vid', vid);
    }
    return vid;
  } catch (_e) {
    return '';
  }
};

export const PresencePing = () => {
  useEffect(() => {
    const ping = () => {
      if (document.hidden) return;
      api.post('/presence/ping', { visitor_id: getVisitorId() }).catch(() => {});
    };
    ping();
    const t = setInterval(ping, PING_INTERVAL_MS);
    const onVisible = () => { if (!document.hidden) ping(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', onVisible); };
  }, []);
  return null;
};

export default PresencePing;
